module.exports = __webpack_public_path__ + "img/radiaIcon4.f38c9fb2.svg";